import React from 'react';
import PropTypes from 'prop-types';
import AllocationUnitsOperations from './comp/allocationUnitsOperations/AllocationUnitsOperationsConnector';
import AllocationUnitEditorContainer from './comp/allocationUnitEditorContainer/AllocationUnitEditorContainerConnector';
import './manageAllocationUnitsPage.scss';

const title = `Custom Allocation Units`;

class ManageAllocationUnitsPage extends React.Component {
  componentWillMount() {
    document.title = title;
  }

  render(){
    return (
      <div className="manage-allocation-units__page react-page">
        <h1>{ title }</h1>
        <hr />
        <AllocationUnitEditorContainer/>
        <AllocationUnitsOperations />
      </div>
    );
  }
}

ManageAllocationUnitsPage.propTypes = {
  history: PropTypes.shape().isRequired
};

export default ManageAllocationUnitsPage;



// WEBPACK FOOTER //
// ./src/components/manageAllocationUnits/ManageAllocationUnitsPage.js